import { TicketTaxModel } from './tickettax.model';
import { AccountModel } from './account.model';

export class AccountsAndTaxesModel {

  taxes: TicketTaxModel[];
  accounts: AccountModel[];

  constructor() { }
}
